<!--? CONTAINER MAIN -->
<div class="container-main">
    <!--? HEADER -->
    <div class="header-container">
        <!-- TITLE -->
        <span class="title-txt-forgot">{{ 'forgotpass.title' | translate }}</span>
        <!-- SUBTITLE -->
        <span class="subtitle-txt-forgot">{{ 'forgotpass.subheader' | translate }}</span>
    </div>
</div>

<!-- FORM -->
<form autocomplete="off"
     style="margin-bottom: 33px;"
     [formGroup]="formularioForgot">

    <!-- ? FORGOT PASSWORD ------------------------------------------------>
    <!-- SPAN -->
    <span class="span-username">
        {{ 'inputs.email' | translate }}
    </span>

    <!-- INPUT -->

    <input
        name="user"
        maxlength="50"
        placeholder="{{ 'inputs.email' | translate }}"
        required
        autocomplete="off"
        required
        class="input-form"
        formControlName="email"
        [ngClass]="{
        'is-invalid': submitted === true && this.typeMsg === 'error' || this.typeMsg === 'warning',
        'input-auth-success': submitted === true && this.typeMsg === 'success',
        '' : submitted === false }">

        <!-- VALIDATIONS -->
        <span *ngIf="this.typeMsg === 'warning'" class="invalid-tooltip {{styles_message}}">
            {{'message.empty_email' | translate}}
        </span>

        <span *ngIf="this.typeMsg === 'error'" class="invalid-tooltip {{styles_message}}">
                {{'message.error_email' | translate}}
        </span>

        <span *ngIf="this.typeMsg === 'success'" class="invalid-tooltip {{styles_message}}">
                {{this.tMsg | translate}}
        </span>

        <!--? BUTTONS -->
        <div class="btn-align">
			<app-button routerLink="/auth/login" btnType="secondaryMedium" btnNombre="buttons.back">

			</app-button>
            <!-- <button
                type="submit"
                class="btn-auth-secondary"
                routerLink="/auth/login">
                {{ 'buttons.back'| translate | titlecase }}
            </button> -->

            <!-- BUTTON SUBMITT -->

			<app-button *ngIf="btnDisabled===true"  btnType="primaryMedium" [activo]="true" btnNombre="buttons.send">

			</app-button>
			<app-button *ngIf="btnDisabled===false"  btnType="primaryMedium" [activo]="false" btnNombre="buttons.send" (click)="validate()">

			</app-button>

        </div>

</form>

